function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M229.872,16c48.577,0.057,87.943,39.423,88,88v32c0.024,0.154,0.056,0.306,0.096,0.456 c-36.454,4.07-64.042,34.863-64.096,71.544c0,4.418,3.582,8,8,8h24.8c4.396,21.65,25.51,35.636,47.16,31.24 c15.741-3.196,28.044-15.499,31.24-31.24h24.8c4.418,0,8-3.582,8-8c-0.054-36.681-27.642-67.474-64.096-71.544 c0.04-0.15,0.072-0.302,0.096-0.456v-32c0-57.438-46.562-104-104-104s-104,46.562-104,104v336h-48c-4.418,0-8,3.582-8,8v24 c0,4.418,3.582,8,8,8h112c4.418,0,8-3.582,8-8v-24c0-4.418-3.582-8-8-8h-48V104C141.929,55.423,181.295,16.057,229.872,16z  M325.872,232c-10.168-0.012-19.229-6.418-22.632-16h45.264C345.101,225.582,336.04,231.988,325.872,232z M333.828,152.524 c24.61,3.532,43.944,22.867,47.476,47.476H270.44C274.834,169.386,303.213,148.13,333.828,152.524z M181.872,456v8h-96v-8 H181.872z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M325.872,256c-4.418,0-8,3.582-8,8v32c0,4.418,3.582,8,8,8s8-3.582,8-8v-32C333.872,259.582,330.29,256,325.872,256z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M376.8,280.208l-16-27.712c-2.183-3.841-7.067-5.185-10.908-3.002c-3.841,2.183-5.185,7.067-3.002,10.908 c0.018,0.031,0.036,0.062,0.054,0.093l16,27.712c2.183,3.841,7.067,5.185,10.908,3.002c3.841-2.183,5.185-7.067,3.002-10.908 C376.836,280.27,376.818,280.239,376.8,280.208z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M406.173,245.126c-0.031-0.018-0.062-0.036-0.093-0.054l-27.712-16c-3.811-2.235-8.713-0.957-10.948,2.854 c-2.235,3.811-0.957,8.713,2.854,10.948c0.031,0.018,0.062,0.036,0.093,0.054l27.712,16c3.811,2.235,8.713,0.957,10.948-2.854 C411.263,252.262,409.985,247.361,406.173,245.126z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M284.272,232c-2.209-3.826-7.102-5.137-10.928-2.928l-27.712,16c-3.841,2.183-5.185,7.067-3.002,10.908 c2.183,3.841,7.067,5.185,10.908,3.002c0.031-0.018,0.062-0.036,0.093-0.054l27.712-16 C285.17,240.719,286.481,235.826,284.272,232z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M301.872,249.6c-3.826-2.209-8.719-0.898-10.928,2.928l-16,27.712c-2.235,3.811-0.957,8.713,2.854,10.948 c3.811,2.235,8.713,0.957,10.948-2.854c0.018-0.031,0.036-0.062,0.054-0.093l16-27.712 C307.009,256.702,305.698,251.809,301.872,249.6z"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function Svg119(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    fill: "inherit",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg119);
export default __webpack_public_path__ + "static/media/1_19.303d27f2.svg";
export { ForwardRef as ReactComponent };